import React from 'react';
import { cn } from '@express-labs/raven-tools';

import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const AlertIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--alertIcon')}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M12 3.5a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm0 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm1 11v2h-2v-2h2zm0-8v6h-2v-6h2z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default AlertIcon;
